import { systemRequest } from "../../utils/systemRequest";

/** GET /system/api-key/page */
export const getApiKeyPageApi = (params: ApiKey.ApiKeyPageQuery = {}) =>
  systemRequest<ApiKey.ApiKeyPageResponse>("/api-key/page", {
    method: "GET",
    params: {
      pageNo: params.pageNo ?? 1,
      pageSize: params.pageSize ?? 100,
    },
  });

/** POST /system/api-key/create */
export const createApiKeyApi = (body: ApiKey.ApiKeyCreateParams) =>
  systemRequest<ApiKey.ApiKeyCreateResponse>("/api-key/create", {
    method: "POST",
    body,
  });

/** PUT /system/api-key/update-name */
export const updateApiKeyNameApi = (body: ApiKey.ApiKeyUpdateNameParams) =>
  systemRequest<ApiKey.ApiKeyBooleanResponse>("/api-key/update-name", {
    method: "PUT",
    body,
  });

/** DELETE /system/api-key/delete */
export const deleteApiKeyApi = (id: number) =>
  systemRequest<ApiKey.ApiKeyBooleanResponse>("/api-key/delete", {
    method: "DELETE",
    params: { id },
  });
